import { Area, AreaChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Reading } from "./api";

const dateFormatter = (date: Date) => {
  return `${date.getDate()}/${date.getMonth()}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
};

export default function Graph({ data, data_key, colour, max_y }: { data: Reading[], data_key: string, colour: string, max_y?: number }) {
  return (
    <ResponsiveContainer width="80%" height={300}>
      <AreaChart
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 60,
        }}
      >
        <defs>
          <linearGradient id={"colour" + data_key} x1="0" y1="0" x2="0" y2="1">
            <stop offset="25%" stopColor={colour} stopOpacity={0.8} />
            <stop offset="95%" stopColor={colour} stopOpacity={0.2} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="timestamp" tickFormatter={dateFormatter} />
        {
          max_y ? <YAxis domain={[0, max_y]} /> : <YAxis />
        }
        <Tooltip />
        <Legend verticalAlign="top" align="right"/>
        <Area type="monotone" dataKey={data_key} stroke={colour} fill={"url(#colour" + data_key + ")"} />
      </AreaChart>
    </ResponsiveContainer>
  );
}
